import { render } from "./mvt-poimarker.vue?vue&type=template&id=53a678c4"
import script from "./mvt-poimarker.js?vue&type=script&lang=js"
export * from "./mvt-poimarker.js?vue&type=script&lang=js"

import "./mvt-poimarker.vue?vue&type=style&index=0&id=53a678c4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__